import Vue from "vue";

export class BaseModel {
    constructor(params) {
        this._params = Object.keys(params);
        Object.assign(this, this.extract(params));
    }

    extract(data) {
        let Data = {};

        if (data === undefined) {
            return Data;
        }

        this.$fields().forEach(field => {
            if (data[field] !== undefined) {
                Data[field] = data[field];
            }
        });

        delete this._params;

        return Data;
    }

    $fields() {
        return [];
    }
}
